import styled from "styled-components";

export const styles = {
  titleName: {
    fontFamily: "Kanit",
    fontSize: "24px",
    color: "black",
    paddingTop: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  accessLevelTitle: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    color: "#323232",
    textAlign: "left",
    paddingTop: "2px",
  },
  date: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    color: "#919191",
    textAlign: "left",
    display: "block",
  },
  dAndPrint: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    paddingTop: "7px",
    paddingLeft: "2px",
  },
  downloadAndPrint: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    color: "#0D5FBE",
    textAlign: "left",
    paddingTop: "8px",
  },
  safetyEnabled: {
    fontFamily: "Open Sans",
    fontSize: "15px",
    color: "#0D5FBE",
    textAlign: "left",
    fontWeight: "bold",
    paddingTop: "7px",
  },
};

export const ButtonLocked = styled.div`
  & button {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
    color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
    border: 1.3px solid ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
    &:hover {
      background: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
      color: #ffffff;
    }
  }
`;
export const ButtonUnLocked = styled.div`
  & button {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
    color: ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
    border: 1.3px solid ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
    &:hover {
      background: ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
    }
  }
`;

export const ManagementPanelWrapper = styled.div`
  background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  .card {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  header {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  .bg-white {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
  }
  .assetTableszOver {
    background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  }
  .buttontabpanels span {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  .title-style,
  .asset-type-size,
  .asset-type-size span {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  .assetTableView p {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  label {
    color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  }
  .input-group-text {
    background-color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  }
  input.form-control {
    border: 1px solid ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"} !important;
  }
  .form-control {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  .form-control:disabled {
    background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"} !important;
    color: ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"} !important;
  }
  input.form-control::placeholder {
    color: ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"} !important;
  }
  p.statusStyle {
    color: ${({ theme }) => theme.colors.grayL1 || "#323232"} !important;
  }
  .noSection p {
    font-family: "Open Sans", sans-serif;
    font-size: 14px !important;
    color: ${({ theme }) => theme.colors.grayL3 || "#676767"} !important;
  }
`;

export const AssetOverviewCard = styled.div`
  position: relative;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  z-index: 0;
  display: block;
  height: calc(100vh - 322px);
  @media (max-width: 1100px) {
    height: 100%;
    display: block;
  }
`;

export const AssetOverviewCardBody = styled.div`
  min-height: 1px;
  padding: 1rem;
  @media (max-width: 1100px) {
    padding: 0.1rem;
  }
`;

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 20% 30%;
  @media (max-width: 1100px) {
    width: 100%;
    display: block;
  }
`;
export const WrapperDiv = styled.div`
  flex: 1;
  padding: 0px 5px;
  @media (max-width: 1100px) {
    float: right;
    text-align: end;
    margin-right: 10px;
  }
`;

export const WrapperDivDetails = styled.div`
  float: left;
  display: flex;
`;
export const FullNameSpan = styled.div`
  font-family: Kanit;
  font-size: 24px !important;
  line-height: 30px;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media (max-width: 1100px) {
    font-size: 20px !important;
    line-height: 25px;
  }
`;
export const HeadingSpan = styled.div`
  font-family: "Open Sans";
  font-size: 13px !important;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 2px;
  @media (max-width: 1100px) {
  }
`;
export const HeadingDiv = styled.div`
  font-family: "Open Sans";
  font-size: 13px !important;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media (max-width: 1100px) {
  }
`;

export const SwitchWrapper = styled.div`
  text-align: right;
  padding-left: 10px;
  flex: 0;
  label {
    margin: 0px !important;
  }
  @media (max-width: 1100px) {
    display: block;
    clear: both;
    width: 100%;
    margin: 10px 0px !important;
    overflow: hidden;
    text-align: left;
    float: left;
  }
`;

export const ImageAndDescDiv = styled.div`
  flex: 1;
  display: flex;
  @media (max-width: 1100px) {
    width: 50%;
    display: block;
    float: left;
    margin-top: 15px;
  }
`;
export const WrapperDesDiv = styled.div`
  padding: 0px 10px;
  display: grid;
`;
export const ImagWrapperDiv = styled.div`
  @media (max-width: 1100px) {
    display: none;
  }
`;

export const StatusHead = styled.div`
  @media (max-width: 1100px) {
    display: none;
  }
`;
export const StatusMobileRender = styled.div`
  display: none;
  @media (max-width: 1100px) {
    display: block;
    label {
      margin: 10px 0px !important;
    }
  }
`;
export const StatusDesktopRender = styled.div`
  display: block;
  @media (max-width: 1100px) {
    display: none;
  }
`;

export const TabComponentDiv = styled.div`
  .nav a {
    padding: 7px 0px;
  }
  .nav-tabs {
    margin-top: 10px;
  }
  .nav-link {
    font-size: 14px !important;
  }
  .tab-content {
    padding: 0px 0px 0px 0px;
  }
  @media (max-width: 1100px) {
    clear: both;
    width: 95%;
    margin: auto;
  }
`;

export const NoSectionStyle = styled.div`
  display: block;
  height: calc(100vh - 360px);
  align-content: center;
  clear: both;
  display: block;
  font-family: "Open Sans", sans-serif;
  font-size: 14px !important;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"} !important;
  p {
    margin-bottom: 0px;
  }
  .clickDesktop {
    display: block;
    @media (max-width: 1100px) {
      display: none;
    }
  }
  .tapMobile {
    display: none;
    @media (max-width: 1100px) {
      display: block;
    }
  }
`;

export const ButtonWrapperCol = styled.div`
  flex: 1;
  float: left;
  display: inline-flex;

  .col {
    padding-right: 0px;
  }
`;

export const ButtonWrapperRow = styled.div`
  display: flex;
  @media (max-width: 1100px) {
    ${ButtonWrapperCol} {
      &:last-child {
        flex: 2;
      }
    }
  }
`;

export const ButtonWraperAdjust = styled.div`
  margin-left: 10px;
`;
